export default __webpack_public_path__ + "8bc576ff8d2c23311314c46764c3aa15.png";